import React from "react";
import CustomSelect from "../../../CommonComponents/Select/CustomSelect";
import {
  Typography,
  FormControl,
  Grid,
  Radio,
  useRadioGroup,
  FormControlLabel,
  RadioGroup,
} from "@mui/material";
import CommonButton from "../../../CommonComponents/CommonButton";
import { useEffect } from "react";
import {
  getGradeCasesByCaseNo,
  getGradeCaseInfo,
} from "../../../Services/caseManagement.service";
import { useState } from "react";
import { useSelector } from "react-redux";
import useToaster from "../../../customHook/useToaster";
import { submitGradeCase } from "../../../Services/caseManagement.service";
import { styled } from "@mui/material/styles";

const radioButtonCss = {
  display: "flex",
  alignItems: "center",
  marginTop: "0.62rem",
  justifyContent: "space-around",
};

const GradeCaseModal = ({ setOpenActionModal }) => {
  const [caseDetails, setCaseDetails] = useState(null);
  const [selectedDetails, setSelectedDetails] = useState({
    gradeId: "",
    status: "",
    subStatus: "",
    fraud: "",
  });
  const [selectedRadioValue, setSelectedRadioValue] = useState("");

  const handleRadioChange = (event) => {
    setSelectedRadioValue(event.target.value);
  };
  const caseId = useSelector((state) => state?.CaseDescriptionSlice?.caseId);
  const { showToast } = useToaster();

  const handleChange = (e) => {
    let targetEle = e?.target?.name;
    let targetVal = e?.target?.value;
    let gradeId =
      targetEle === "gradeId" ? targetVal : selectedDetails?.gradeId;
    let status =
      targetEle === "gradeId"
        ? ""
        : targetEle === "status"
        ? targetVal
        : selectedDetails?.status;
    let subStatus =
      targetEle === "gradeId"
        ? ""
        : targetEle === "status"
        ? ""
        : targetEle === "subStatus"
        ? targetVal
        : selectedDetails?.subStatus;
    setSelectedDetails((prev) => {
      return {
        ...prev,
        gradeId,
        status,
        subStatus,
      };
    });
  };
  const StyledFormControlLabel = styled((props) => (
    <FormControlLabel {...props} />
  ))(({ theme, checked }) => ({
    //   ".MuiFormControlLabel-label": checked && {
    //     color: "red",
    //   },
  }));
  function MyFormControlLabel(props) {
    const radioGroup = useRadioGroup();

    let checked = false;

    if (radioGroup) {
      checked = radioGroup.value === props.value;
    }

    return <StyledFormControlLabel checked={checked} {...props} />;
  }

  const submitHandler = (e) => {
    if (
      selectedDetails?.gradeId &&
      selectedDetails?.status &&
      selectedDetails?.subStatus &&
      selectedRadioValue
    ) {
      // let keys = Object?.keys(caseDetails?.gradeCaseDropValue);
      // let values = Object?.values(caseDetails?.gradeCaseDropValue);
      let gradeObj = caseDetails?.gradeCaseDropValue?.find(
        (obj) => obj?.case_grade === selectedDetails?.gradeId
      );
      let gradeId = gradeObj?.grade_master_id;
      let payload = {
        ...selectedDetails,
        gradeId,
        fraud: selectedRadioValue,
      };
      submitGradeCase(caseId, payload)
        ?.then((response) => {
          if (response?.success) {
            // dispatch(
            //   setCaseActions({
            //     actionType: actionModalType,
            //     caseNo: selectedCaseId,
            //   })
            // );
            setOpenActionModal(false);
            showToast("Grade case submitted successfully", "success", true);
          }
        })
        ?.catch((err) => {
          showToast(err?.response?.data?.message, "error", true);
        });
    } else {
      showToast("Please select grade details", "warning", true);
    }
  };

  useEffect(() => {
    if (caseId) {
      getGradeCasesByCaseNo(caseId)
        ?.then((response) => {
          if (response?.success) {
            setCaseDetails(response?.data);
          }
        })
        ?.catch((err) => {
          showToast(err?.response?.data?.message, "error", true);
        });
    }
  }, [caseId]);

  useEffect(() => {
    if (caseId) {
      getGradeCaseInfo(caseId)
        ?.then((response) => {
          if (response?.success) {
            let { grade_case, grade_status, grade_sub_status, fraud } =
              response?.data;
            setSelectedRadioValue(fraud);
            setSelectedDetails((prev) => {
              return {
                ...prev,
                gradeId: grade_case,
                status: grade_status,
                subStatus: grade_sub_status,
                fraud: fraud,
              };
            });
          }
        })
        ?.catch((err) => {
          showToast(err?.response?.data?.message, "error", true);
        });
    }
  }, [caseId]);

  useEffect(() => {
    // from backend if we are getting radioValue and if user want  to change the radio value then this function will work
    if (selectedRadioValue) {
      setSelectedDetails((prev) => ({
        ...prev,
        fraud: "",
      }));
    }
  }, [selectedRadioValue]);
  return (
    <Grid
      // container
      // spacing={0}
      sx={{
        padding: "0px",
        margin: "0px",
        width: "100%",
        height: "100%",
      }}
    >
      <Grid item xs={12}>
        <Typography
          sx={{
            fontSize: "1.6rem",
            lineHeight: "1.94rem",
            width: "34.3rem",
            height: "1.9rem",
            fontWeight: "600",
            paddingTop: "0.5rem",
            color: "#505050",
          }}
        >
          Grade Case
        </Typography>
      </Grid>
      <Grid item xs={12} sx={{ height: "28.6rem", paddingTop: "1.6rem" }}>
        <FormControl sx={{ width: "100%" }}>
          <Grid container spacing={0}>
            <Grid item xs={12}>
              <Typography sx={{ color: "#7C7C7C", fontSize: "1.4rem" }}>
                Fraud Type
              </Typography>
              <RadioGroup
                name="use-radio-group"
                value={
                  selectedDetails?.fraud
                    ? selectedDetails?.fraud
                    : selectedRadioValue
                }
                onChange={handleRadioChange}
              >
                <div style={radioButtonCss}>
                  <MyFormControlLabel
                    labelPlacement="end"
                    value="soft fraud"
                    label={
                      <Typography sx={{ fontSize: "13px" }}>
                        Soft Fraud
                      </Typography>
                    }
                    control={
                      <Radio
                        sx={{
                          "&.Mui-checked": {
                            color: "#E94D51",
                          },
                          "& .MuiSvgIcon-root": {
                            fontSize: "18px",
                          },
                        }}
                      />
                    }
                  />
                  <MyFormControlLabel
                    labelPlacement="end"
                    value="hard fraud"
                    label={
                      <Typography sx={{ fontSize: "13px" }}>
                        Hard Fraud
                      </Typography>
                    }
                    control={
                      <Radio
                        sx={{
                          "&.Mui-checked": {
                            color: "#E94D51",
                          },
                          "& .MuiSvgIcon-root": {
                            fontSize: "18px",
                          },
                        }}
                      />
                    }
                  />
                  <MyFormControlLabel
                    labelPlacement="end"
                    value="no fraud"
                    label={
                      <Typography sx={{ fontSize: "13px" }}>
                        No Fraud
                      </Typography>
                    }
                    control={
                      <Radio
                        sx={{
                          "&.Mui-checked": {
                            color: "#E94D51",
                          },
                          "& .MuiSvgIcon-root": {
                            fontSize: "18px",
                          },
                        }}
                      />
                    }
                  />
                </div>
              </RadioGroup>
            </Grid>
            <Grid item xs={12}>
              <CustomSelect
                label="Case Grade"
                placeholder="Select"
                customSelectValue={
                  selectedDetails?.gradeId ? selectedDetails?.gradeId : ""
                }
                name="gradeId"
                options={
                  caseDetails
                    ? [
                        ...caseDetails?.gradeCaseDropValue?.map(
                          (obj) => obj?.case_grade
                        ),
                      ]
                    : []
                }
                handleChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sx={{ paddingTop: "0.8rem" }}>
              <CustomSelect
                disabled={!selectedDetails?.gradeId}
                label="Grade Status"
                placeholder="Select"
                customSelectValue={
                  selectedDetails?.status ? selectedDetails?.status : ""
                }
                name="status"
                options={
                  selectedDetails?.gradeId && caseDetails
                    ? [...caseDetails?.gradeList?.map((grade) => grade?.status)]
                    : []
                }
                handleChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sx={{ paddingTop: "0.8rem" }}>
              <CustomSelect
                disabled={!selectedDetails?.status}
                label="Grade Sub Status"
                placeholder="Select"
                customSelectValue={
                  selectedDetails?.subStatus ? selectedDetails?.subStatus : ""
                }
                name="subStatus"
                options={
                  selectedDetails?.status && caseDetails
                    ? caseDetails?.gradeList
                        ?.find(
                          (grade) => selectedDetails?.status === grade?.status
                        )
                        ?.sub_status_array?.map((obj) => obj?.grade_sub_status)
                    : []
                }
                handleChange={handleChange}
              />
            </Grid>
            <Grid
              item
              xs={12}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                paddingTop: "1.6rem",
              }}
            >
              <div>
                <CommonButton
                  label="Submit"
                  smallButton={true}
                  filledButton={true}
                  onClick={submitHandler}
                  fontSize="1.4rem"
                  sx={{ width: "10rem", height: "4rem" }}
                />
              </div>
            </Grid>
          </Grid>
        </FormControl>
      </Grid>
    </Grid>
  );
};

export default GradeCaseModal;
